import { render, staticRenderFns } from "./GroupMemberTableMenu.vue?vue&type=template&id=4c7c5275&scoped=true&"
import script from "./GroupMemberTableMenu.vue?vue&type=script&lang=js&"
export * from "./GroupMemberTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c5275",
  null
  
)

export default component.exports